var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9964 109.663C52.6848 109.663 46.7411 103.719 46.7411 96.4075H56.1755C56.1755 98.5302 57.9209 100.228 59.9964 100.228C62.072 100.228 63.8174 98.483 63.8174 96.4075H73.2517C73.2989 103.672 67.3552 109.663 59.9964 109.663Z",
    fill: "#7175AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3412 76.7344C26.0296 76.7344 20.0859 70.7907 20.0859 63.479H29.5203C29.5203 65.6017 31.2657 67.2999 33.3412 67.2999C35.4168 67.2999 37.1621 65.5546 37.1621 63.479H46.5965C46.6437 70.7907 40.6529 76.7344 33.3412 76.7344Z",
    fill: "#FFA726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7456 96.2721C79.4339 96.2721 73.4903 90.3284 73.4903 83.0167V23.344C73.4903 16.0323 79.4339 10.0886 86.7456 10.0886C94.0572 10.0886 100.001 16.0323 100.001 23.344V82.9695C100.048 90.3284 94.0572 96.2721 86.7456 96.2721ZM86.7456 19.523C84.6228 19.523 82.9247 21.2684 82.9247 23.344V82.9695C82.9247 85.0923 84.67 86.7905 86.7456 86.7905C88.8211 86.7905 90.5665 85.0451 90.5665 82.9695V23.344C90.6137 21.2684 88.8683 19.523 86.7456 19.523Z",
    fill: "#FFA726"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 96.2778C52.6885 96.2778 46.7448 90.3341 46.7448 83.0224V10H56.1792V83.0224C56.1792 85.1452 57.9245 86.8434 60.0001 86.8434C62.0757 86.8434 63.821 85.098 63.821 83.0224V10H73.2554V83.0224C73.3026 90.3341 67.3589 96.2778 60.0001 96.2778Z",
    fill: "#7175AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5577 91.5578H37.1234V23.3469C37.1234 21.2242 35.378 19.526 33.3025 19.526C31.2269 19.526 29.4344 21.2713 29.4344 23.3469V91.5578H20V23.3469C20 16.0352 25.9437 10.0916 33.2553 10.0916C40.5669 10.0916 46.5106 16.0352 46.5106 23.3469V91.5578H46.5577Z",
    fill: "#FFA726"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15182f2d32e23fc6454ea85f8b48cbb2.svg";
export { ForwardRef as ReactComponent };